import { render, staticRenderFns } from "./ImmediateButton.vue?vue&type=template&id=326e0ffe&scoped=true"
import script from "./ImmediateButton.vue?vue&type=script&lang=js"
export * from "./ImmediateButton.vue?vue&type=script&lang=js"
import style0 from "./ImmediateButton.vue?vue&type=style&index=0&id=326e0ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326e0ffe",
  null
  
)

export default component.exports